const invertedMessages = {
  // Client Credentials
  'Enter client name': 'Auth.Placeholder.EnterClientName',
  'e.g. admin, viewer': 'Auth.Placeholder.RolesExample',
  'Select roles': 'Auth.Placeholder.SelectRoles',
  'Optional description': 'Auth.Placeholder.OptionalDescription',
  'Search clients...': 'Auth.Placeholder.SearchClients',
};

export default invertedMessages;
